console._trace = console.trace; 
console.trace = function(){
	console.groupCollapsed.apply(console, arguments);
	console._trace();
	console.groupEnd();
};

var domReady = function(callback){
	document.addEventListener("DOMContentLoaded", callback,{once: true});
};
if (!Element.prototype.scrollIntoViewIfNeeded) {
	Element.prototype.scrollIntoViewIfNeeded = function (centerIfNeeded) {
		centerIfNeeded = arguments.length === 0 ? true : !!centerIfNeeded;
		
		var parent = this.parentNode,
		parentComputedStyle = window.getComputedStyle(parent, null),
		parentBorderTopWidth = parseInt(parentComputedStyle.getPropertyValue('border-top-width')),
		parentBorderLeftWidth = parseInt(parentComputedStyle.getPropertyValue('border-left-width')),
		
		overTop = this.offsetTop - parent.offsetTop < parent.scrollTop,
		overBottom = (this.offsetTop - parent.offsetTop + this.clientHeight - parentBorderTopWidth) > (parent.scrollTop + parent.clientHeight),
		overLeft = this.offsetLeft - parent.offsetLeft < parent.scrollLeft,
		overRight = (this.offsetLeft - parent.offsetLeft + this.clientWidth - parentBorderLeftWidth) > (parent.scrollLeft + parent.clientWidth),
		alignWithTop = overTop && !overBottom;
		
		if ((overTop || overBottom) && centerIfNeeded) {
			parent.scrollTop = this.offsetTop - parent.offsetTop - parent.clientHeight / 2 - parentBorderTopWidth + this.clientHeight / 2;
		}
		if ((overLeft || overRight) && centerIfNeeded) {
			parent.scrollLeft = this.offsetLeft - parent.offsetLeft - parent.clientWidth / 2 - parentBorderLeftWidth + this.clientWidth / 2;
		}
		if ((overTop || overBottom || overLeft || overRight) && !centerIfNeeded) {
			this.scrollIntoView(alignWithTop);
		}
	};
}

// Kop�rov�n� innerText p�i click na element s class selectable
var textSelector = function(scope){
	if(!scope || !(scope instanceof HTMLElement)) scope = document;
	var selectText = target=>{
		if (document.body.createTextRange) {
	        const range = document.body.createTextRange();
	        range.moveToElementText(target);
	        range.select();
	    } else if (window.getSelection) {
	        const selection = window.getSelection();
	        const range = document.createRange();
	        range.selectNodeContents(target);
	        selection.removeAllRanges();
	        selection.addRange(range);
	    }
	};
	[...scope.querySelectorAll('.selectable:not(.selectable-initialized)')].forEach(el=>{
		if(el.innerText.trim().length > 0){
			el.addEventListener('click',e=>{
				const target = e.currentTarget;
				
				//pokud se sna��m ru�n� vybrat jen ��st textu, tak nevyb�rat cel� obsah elementu!
				let activeSelection = window.getSelection();
				if(e.target.contains(activeSelection.baseNode) && !activeSelection.isCollapsed) return;
				
				// toto zat�m vyhovuje v�t�in� prohl�e��
		    	if(navigator.clipboard && navigator.clipboard.writeText && typeof navigator.clipboard.writeText === "function"){
					selectText(target);
					navigator.clipboard.writeText(target.innerText).then(()=>{
						require(['EBContext_SessionUtils'], ()=>{ EBContext.session.notify(EBContext.resource('TEXT_ZKOPIROVAN'), 'info')});
					});
				} else {
					
					// toto je spr�vn� implementace dle W3C
					navigator.permissions.query({name: "clipboard-write"}).then(result=>{
						if(result.state == "granted" || result.state == "prompt"){
							selectText(target);
							navigator.clipboard.writeText(target.innerText).then(()=>{
								require(['notifyjs'], ()=>{ EBContext.session.notify(EBContext.resource('TEXT_ZKOPIROVAN'), 'info')});
							});
						} else {
							
							// toto je depreceated �e�en� jako fallback pro star� prohl�e�e
							selectText(target);
							document.execCommand("copy");
							require(['notifyjs'], ()=>{ EBContext.session.notify(EBContext.resource('TEXT_ZKOPIROVAN'), 'info')});
						}
					});
				}
			});
		}
		if(!el.classList.contains('selectable-initialized')){
			let ci = document.createElement('i');
			ci.className="fas " + (el.innerText.trim().length > 0 ? "fa-paste me-2" : "fa-empty-set" ) + " text-muted";
			(el.firstChild ? el.insertBefore(ci, el.firstChild) : el.append(ci)); //ekvivalent el.prepend(ci)
		}
		el.classList.add('selectable-initialized');
	});

	/*	FF nech�pe co po n�m v `navigator.permissions.query({name: "clipboard-write"})` n�m chci, proto�e  *
	 *  p��stup k z�pisu do clipboardu z callbacku user-generated eventu bere jako samoz�ejmost, tak       *
	 *  permission "clipboard-write" nezn�, a vrac� tedy "Denied" - proto se podm�nka ignoruje             */
};
var preselect = function(scope){
	if(!scope || !(scope instanceof HTMLElement)) scope = document;
	let select = e=>{
		try {
			e.target.select();
		} catch (e) {
			console.error(e);
		}
	};
	[...scope.querySelectorAll('input.preselect:not(.preselect-initialized)')].forEach(el=>{
		el.addEventListener('focus', select);
		el.addEventListener('click', select);
		el.classList.add('preselect-initialized');
	});
};
var deselect = function(){
	if (window.getSelection) {
		let sel = window.getSelection();
		if(sel.empty) sel.empty();
		if(sel.removeAllRanges) sel.removeAllRanges();
	}
};
var selectpicker = function(scope){
	EBContext.await(['jquery', 'bootstrap-select-config'], ()=>{
		if(!scope || !(scope instanceof HTMLElement)) scope = document;
		if(!$.fn.selectpicker.Constructor.BootstrapVersion) initSelectPicker();
		[...scope.querySelectorAll('.selectpicker')].forEach(el=>{
			$(el).selectpicker();
			if(!el.dataset.selectpickerInit){
				el.dataset.selectpickerInit = true;
				el.addEventListener('change', ev=>$(ev.currentTarget).selectpicker('refresh')); // nutn� kv�li autofillu!!!
			}
		});
	});
};
var tooltip = function(scope){
	EBContext.await('bootstrap', ()=>{
		if(!scope || !(scope instanceof HTMLElement)) scope = document;
		[...scope.querySelectorAll('[data-bs-toggle="tooltip"]')].map(el=>{
			if(bootstrap.Tooltip.getInstance(el)) return;
			return new bootstrap.Tooltip(el);
		});
		[...scope.querySelectorAll('[data-bs-toggle="popover"]')].map(el=>{
			if(bootstrap.Popover.getInstance(el)) return;
			return new bootstrap.Popover(el);
		});
	});
};
var ellipsisTitle = function(scope){
	EBContext.await(['EBContext','bootstrap'], ()=>{
		let updateEllipsis = function(el){
			if(el.getAttribute('data-original-title') === null && EBContext.utils.element.isTruncated(el) && !el.title){
				el.setAttribute('data-original-title', el.title);
				el.title = el.innerText;
				el.tooltip = new bootstrap.Tooltip(el);
			}
			else if(el.getAttribute('data-original-title') !== null && !EBContext.utils.element.isTruncated(el)){
				el.title = el.getAttribute('data-original-title');
				el.removeAttribute('data-original-title');
				el.tooltip.dispose();
			}
		};
		let observer = new IntersectionObserver(entries=>{
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					updateEllipsis(entry.target);
				}
			});
		} , {root: null, rootMargin: '0px', threshold: 1.0});
		if(!scope || !(scope instanceof HTMLElement)) scope = document;
		[...scope.querySelectorAll('.text-truncate:not(.ignoretooltip):not([data-observed]),.text-clamp:not(.ignoretooltip):not([data-observed])')].forEach(el=>{
			if(!EBContext.utils.element.isVisible(el) && !el.hasAttribute('data-observed')){
				observer.observe(el);
				el.setAttribute('data-observed', '');
			}
			updateEllipsis(el);
		});
	});
};
var processLinks = function(scope){
	if(!scope || !(scope instanceof HTMLElement)) scope = document;
	let iconEl = '<i class="fas fa-sm fa-fw me-1 fa-external-link-alt elicon" title="'+EBContext.resource('EXTERNI_ODKAZ')+'"></i>';
	[...scope.querySelectorAll('a[href],[data-href]')].forEach(el=>{
		if(el.getAttribute('data-ajax') === 'off') return;
		let href = (el.href || el.getAttribute('data-href') || '').toString();
		let domain = location.href.toString().match(/(http:\/\/|https:\/\/)([^\/]+)/gi);
		if(domain){
			domain = domain[0];
			let protocol = domain.match(/(http:\/\/|https:\/\/)/gi);
			if(protocol){
				protocol = protocol[0];
				if(domain.indexOf(protocol)===0) domain = domain.substr(protocol.length);
			}
		}
		protocol = href.match(/(http:\/\/|https:\/\/)/gi);
		if(protocol){
			protocol = protocol[0];
			if(href.indexOf(protocol)===0) href = href.substr(protocol.length);
		}
		if(href.indexOf('/')!==0 && href.indexOf(domain)!==0 && !href.match(/^(mailto:|tel:|action:|javascript:(;|\/\/))/gi)){
			if(el.tagName === 'A'){
				// Odkaz m��� pry�, tak doplnit o nofollow a noopener
				el.target = el.target || "_blank";
				el.rel = el.rel || "nofollow noopener";
			} else {
				EBContext.utils.element.setOverride(el, 'onclick', e=>{
					e.stopPropagation();
					let el = e.currentTarget;
					let href = (el.href || el.getAttribute('data-href') || '').toString();
					window.open(href, '_blank', 'noopener').focus();
					return false;
				});
			}
			// Doplnit o ikonu pouze pokud neobsahuje child elementy kter� nejsou inline a je�t� tam nen�
			if([...el.children].filter(el=>(el.tagName === 'IMG' || ['inline','inline-block'].indexOf(window.getComputedStyle(el).getPropertyValue('display')) === -1)).length === 0 && el.innerHTML.indexOf(iconEl) === -1){
				el.innerHTML = iconEl + el.innerHTML;
			}
		} else if(href.indexOf('action:') === 0){
			EBContext.utils.element.setOverride(el, 'onclick', e=>{
				e.preventDefault();
				e.stopPropagation();
				let el = e.currentTarget;
				let href = (el.href || el.getAttribute('data-href') || '').toString();
				let actionArr = href.substr(7).split(';');
				let actionObj = EBContext.utils.getObj('actions.' + actionArr[0], EBContext);
				if(typeof actionObj === 'function') actionObj.apply(null, actionArr.slice(1));
				if(EBContext.sidebar) EBContext.sidebar.toggle(false);
				return false;
			});
		} else if(href.indexOf('javascript:') === 0){
			EBContext.utils.element.setOverride(el, 'onclick', e=>{
				e.preventDefault();
				let el = e.currentTarget;
				let href = (el.href || el.getAttribute('data-href') || '').toString();
				let code = href.substring(href.indexOf(':')+1);
				try {
					return window.eval(code);
				} catch (error) {
					console.error('Error while executing JS code', code, error);
				}
				return false;
			});
		}
	});
};
var initSideBanners = function(){
	var banners = [];
	var sideBanner = function(el){
		this.init = el=>{
			this.el = el;
			let dataContent = el.getAttribute('data-sidebanner');
			if(!dataContent) return null;
			let dataArr = dataContent.split(';');
			this.side = dataArr[0];
			this.position = dataArr[1];
			this.alignH = dataArr[2];
			this.alignV = dataArr[3];
			this.maxWidth = dataArr[4];
			let bodyStyles = getComputedStyle(document.body);
			this.bodyRight = parseFloat(bodyStyles.marginRight.replace('px',''));
			this.bodyTop = parseFloat(bodyStyles.paddingTop.replace('px',''));
			this.bodyBottom = parseFloat(bodyStyles.paddingTop.replace('px',''));
			this.updateX();
			setTimeout(()=>{
				this.ro = new ResizeObserver(this.updateX);
				this.ro.observe(document.body);
				if(this.position==='fixed')	document.addEventListener("scroll", this.updateY);
				this.el.style.position = this.position;
				this.el.style.zIndex='unset';
				this.el.style.opacity='1';
			},10);
			document.addEventListener('EBContext.ajaxNav.bodyReloaded', ()=>{
				let parentEl = document.getElementById(this.el.parentElement.id);
				if(!parentEl.contains(this.el)) parentEl.appendChild(this.el);
			});
		};
		this.updateX = ()=>{
			let windowWidth = document.body.clientWidth;
			let parentWidth = this.el.parentElement.clientWidth;
			let parentHeight = this.el.parentElement.clientHeight;
			let bannerCS = getComputedStyle(this.el);
			let bannerWidth = parseFloat(bannerCS.width.replace('px',''));
			let bannerHeight = this.el.clientHeight;
			let sideWidth = (windowWidth-parentWidth)/2;
			if(this.side=='right') sideWidth+=this.bodyRight;
			this.el.style.width=sideWidth+'px'; // Nastav� se max. p��pustn� ���ka dle skute�n� voln�ho prostoru
			bannerWidth = parseFloat(getComputedStyle(this.el).width.replace('px','')); // CSS tu ���ku omez� pomoc� minWidth a maxWidth, tak si ulo��m aktu�ln� velikost
			if(sideWidth < bannerWidth){	// Pokud je ���ka banneru (po kontrole minWidth) v�t�� ne� aktu�ln� voln� prostor, tak banner skr�t
				this.el.style.visibility='hidden';
			} else {	// Banner se zobraz� - napozicovat
				this.el.style.width='unset'; // odebrat explicitn� nastaven� ���ky, aby se banner nenatahoval nad skute�nou ���ku obr�zku
				let bw = parseFloat(getComputedStyle(this.el).width.replace('px','')); // na��st skute�nou velikost banneru
				if(bw > bannerWidth){
					this.el.style.width=bannerWidth+'px'; //pokud je skute�n� velikost banneru v�t�� ne� p�vodn� nastaven�, tak obnovit tu p�vodn� nastavenou
				} else {
					bannerWidth = bw; // jinak ulo�it aktu�ln� skute�nou ���ku banneru aby spr�vn� fungovalo pozicov�n�
				}
				this.el.style.visibility='visible';
				if(this.position==='absolute'){
					if(this.alignH==='inside'){
						if(this.side==='left'){
							this.el.style.right='100%';
						} else {
							this.el.style.left='100%';
						}
					} else if(this.alignH==='outside'){
					 	if(this.side==='left'){
							this.el.style.right=(parentWidth+sideWidth-bannerWidth)+'px';
						} else {
							this.el.style.left=(parentWidth+sideWidth-bannerWidth)+'px';
						}
					} else { // center
					 	if(this.side==='left'){
							this.el.style.right=(parentWidth+(sideWidth-bannerWidth)/2)+'px';
						} else {
							this.el.style.left=(parentWidth+(sideWidth-bannerWidth)/2)+'px';
						}
					 }
					if(this.alignV==='up'){
						this.el.style.top='0';
					} else if(this.alignV==='down'){
						this.el.style.bottom='0';
					} else { //middle
						this.el.style.top=((parentHeight-bannerHeight)/2)+'px';
					}
				} else { // fixed
					if(this.alignH==='inside'){
						if(this.side==='left'){
							this.el.style.left=(sideWidth-bannerWidth)+'px';
						} else {
							this.el.style.right=(sideWidth-bannerWidth)+'px';
						}
					} else if(this.alignH==='outside'){
					 	if(this.side==='left'){
							this.el.style.left='0';
						} else {
							this.el.style.right='0';
						}
					} else { // center
					 	if(this.side==='left'){
							this.el.style.left=((sideWidth-bannerWidth)/2)+'px';
						} else {
							this.el.style.right=((sideWidth-bannerWidth)/2)+'px';
						}
					 }
					this.updateY();
				}
			}
		};
		this.updateY = e=>{ // jen pro position:fixed
			let bannerBCR = this.el.getBoundingClientRect();
			let parentBCR = this.el.parentElement.getBoundingClientRect();
			// console.debug("debug banner "+this.el.id, this, bannerBCR, parentBCR);
			if(bannerBCR.bottom > parentBCR.bottom){
				this.el.style.top='unset';
				this.el.style.bottom=(window.innerHeight-parentBCR.bottom)+'px';
			} else if(parentBCR.top > this.bodyTop){
				this.el.style.bottom='unset';
				this.el.style.top=parentBCR.top+'px';
			} else if(this.alignV==='down'){
				this.el.style.top='unset';
				this.el.style.bottom=this.bodyBottom+'px';
			} else if(this.alignV==='up'){
				this.el.style.top=this.bodyTop+'px';
				this.el.style.bottom='unset';
			} else { //middle
				this.el.style.bottom='unset';
				this.el.style.top=((window.innerHeight-this.el.clientHeight)/2)+'px';
			}
		};
		this.init(el);
		return this;
	};
	[...document.querySelectorAll('.sideBanner')].forEach(el=>banners.push(new sideBanner(el)));
	return banners;
};
var initResponsiveCollapses = function(scope){
	EBContext.await(['EBContext','EBContext_Modal','bootstrap'], ()=>{
		if(!scope || !(scope instanceof HTMLElement)) scope = document;
		[...scope.querySelectorAll('.collapse[data-collapse-breakpoint]')].forEach(el=>new EBContext.modules.ResponsiveCollapse(el));
	});
};
var initFileInputs = function(scope){
	if(!scope || !(scope instanceof HTMLElement)) scope = document;
	[...scope.querySelectorAll('input[type="file"][accept]')].forEach(el=>{
		let onFileChange = e=>{
			let el = e.currentTarget;
			let mimetypes = el.accept.toString().split(',');
			let filesOK = true;
			let msg = EBContext.resource('VYBERTE_PODPOROVANY_TYP_SOUBORU');
			msg += '<br>Podporovan� typy soubor�: ' + mimetypes.join(', ');
			[...el.files].forEach(file=>{
				if(mimetypes.find(mt=>(mt && file.type.indexOf(mt.replace('*',''))===0))){
					msg += `<br><i class="fas fa-fw fa-check text-success me-2"></i>${file.name} (${file.type})`;
				} else {
					msg += `<br><i class="fas fa-fw fa-times text-danger me-2"></i>${file.name} (${file.type})`;
					filesOK = false;
				}
			});
			if(!filesOK) EBContext.alert(msg, null, {heading: EBContext.resource('CHYBA_VALIDACE'), callback: ()=>{el.value = '';}});
		};
		el.addEventListener('change', onFileChange);
	});
};
var getScrollbarWidth = function(){
	// Po��t� se s t�m, �e v�echny scrollbary budou stejn� �irok� jako scrollbar na BODY. Pokud by m�ly b�t n�kter� p�estylovan�, bude pot�eba tuto funkci p�epsat!
	let scrollbarWidth = window.EBContext?.config?.scrollbarWidth;
	if(!scrollbarWidth){
		const outer = document.createElement('div');
		outer.style.visibility = 'hidden';
		outer.style.overflow = 'scroll';
		outer.style.position = 'absolute';
		outer.style.msOverflowStyle = 'scrollbar';
		document.body.appendChild(outer);
		const inner = document.createElement('div');
		outer.appendChild(inner);
		scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
		outer.parentNode.removeChild(outer);
	}
	if(window.EBContext?.config && !window.EBContext.config.scrollbarWidth) window.EBContext.config.scrollbarWidth = scrollbarWidth;
	return scrollbarWidth;
};
var updateFixedPositions = function(){
	const scrollbarWidth = getScrollbarWidth();
	const bodyStyle = window.getComputedStyle(document.body);
	const updateBgPosition = function(el, computedStyle){
		computedStyle = computedStyle || window.getComputedStyle(el);
		if(!el.dataset.origBg) el.dataset.origBg = computedStyle.background;
		if(computedStyle.position==='fixed' && !el.classList.contains('hoverbox')){
			el.style.right = bodyStyle.paddingRight;
			el.style.width = 'auto';
		}
		if(bodyStyle.overflowY==='hidden' && scrollbarWidth > 0 && document.body.scrollHeight > window.innerHeight){
			if(computedStyle.backgroundAttachment==='fixed' || el===document.body){
				if(computedStyle.backgroundSize.substr(0,4)==='100%') {
					el.style.backgroundSize='calc(100% - ' + scrollbarWidth + 'px)';
				}
				el.style.backgroundPositionX='calc(50% - ' + (scrollbarWidth/2) + 'px)';
			}
		} else {
			el.style.background = el.dataset.origBg;
		}
	};
	updateBgPosition(document.body, bodyStyle);
	[...document.querySelectorAll('.container,.container-fluid,[class*="fixed-"]')].forEach(el=>updateBgPosition(el));
};
window.sideBanners = initSideBanners();

window.addEventListener('resize',ellipsisTitle);
document.addEventListener('EBContext.ajaxNav.ready', ellipsisTitle, {once: true});
document.addEventListener('EBContext.ajaxNav.ready', textSelector, {once: true});
document.addEventListener('EBContext.ajaxNav.ready', preselect, {once: true});
document.addEventListener('EBContext.ajaxNav.ready', selectpicker, {once: true});
document.addEventListener('EBContext.ajaxNav.ready', tooltip, {once: true});
document.addEventListener('EBContext.ajaxNav.ready', processLinks, {once: true});
document.addEventListener('EBContext.ajaxNav.ready', initResponsiveCollapses, {once: true});
document.addEventListener('EBContext.ajaxNav.ready', initFileInputs, {once: true});
document.addEventListener('EBContext.ajaxNav.ready', updateFixedPositions, {once: true});
document.addEventListener('EBContext.ajaxNav.navigate', deselect);

domReady(()=>{
	const mutationObserver = new MutationObserver((records, observer)=>{
		let scopesList = [];
		let scope, scope2, bodyClassListChange = false;
		
		for(const record of records){
			scope = record.target.parentElement || record.target;
			if(!scopesList.find(sli=>(sli===scope || sli.contains(scope)))){
				scope2 = scopesList.find(sli=>scope.contains(sli))
				if(scope2){
					scopesList[scopesList.indexOf(scope2)] = scope;
				} else {
					scopesList.push(scope);
				}
			}
		}
		for(const scope of scopesList){
			ellipsisTitle(scope);
			textSelector(scope);
			preselect(scope);
			selectpicker(scope);
			tooltip(scope);
			processLinks(scope);
			initResponsiveCollapses(scope);
		}
	});
	require(['EBContext'], ()=>{ mutationObserver.observe(document.body, {childList: true, subtree: true}) });
	
	const mutationObserver2 = new MutationObserver((records, observer)=>{updateFixedPositions()});
	(()=>{mutationObserver2.observe(document.body, {attributes: true, attributeFilter: ['class']});})();
});

var toggleMoreItems = function(wrapSelector, toggleEl, altText, state){
	// console.trace('toggleMoreItems', arguments);
	let wrapEl = EBContext.utils.element.getElement(wrapSelector);
	if(!wrapEl || !toggleEl) return;
	let options = EBContext.utils.parseObj(toggleEl.getAttribute('data-togglemore') || '{}');
	options = EBContext.utils.extendObj(false, {
		textMore: EBContext.resource('VICE'),
		textLess: EBContext.resource('MENE'),
		type: 'legacy',
		display: 'block',
		itemsSelector: '*',
		container: toggleEl.getAttribute('data-container')
	}, options);
	
	let moreContainerEl, moreEl, closed
	if(options.type === 'responsive'){
		moreContainerEl = wrapEl;
		closed = !![...moreContainerEl.querySelectorAll(options.itemsSelector)].find(el=>!EBContext.utils.element.isVisible(el));
	} else{
		moreContainerEl = wrapEl.parentElement;
		moreEl = moreContainerEl.querySelector('.box-more');
		closed = moreEl.classList.contains('d-none');
	}
	let statusEl = moreContainerEl.querySelector('.box-status');
		
	if(!toggleEl.getAttribute('data-closed-text')){
		toggleEl.setAttribute('data-closed-text', (closed ? toggleEl.innerText : altText));
	}
	if(!toggleEl.getAttribute('data-opened-text')){
		toggleEl.setAttribute('data-opened-text', (closed ? altText : toggleEl.innerText));
	}
	if(state!==undefined) closed = !state;
	if(closed){
		if(options.type === 'responsive'){
			[...moreContainerEl.querySelectorAll(options.itemsSelector)].forEach(el=>{
				el.style.setProperty('display', options.display, 'important');
			});
		} else {
			moreEl.classList.remove('d-none');
		}
		toggleEl.innerText = toggleEl.getAttribute('data-opened-text');
		toggleEl.value = 1;
		statusEl.value = 1;
	}
	else{
		if(options.type === 'responsive'){
			[...moreContainerEl.querySelectorAll(options.itemsSelector)].forEach(el=>{
				el.style.setProperty('display', null);
			});
		} else {
			moreEl.classList.add('d-none');
		}
		toggleEl.innerText = toggleEl.getAttribute('data-closed-text');
		toggleEl.value = 0;
		statusEl.value = 0;
	}
	/* ukl�d�n� stavu p�i otev�en�/zav�en� */
	EBContext.ajaxNav.updateElementState(statusEl);
};
var prepareToggleMore = function(toggleEl, forced){
	if(!EBContext.ajaxNav) return EBContext.ready(()=>prepareToggleMore(toggleEl,forced));
	if(toggleEl.getAttribute('initialized')!==null && !forced) return false;
	let options = EBContext.utils.parseObj(toggleEl.getAttribute('data-togglemore') || '{}');
	options = EBContext.utils.extendObj(false, {
		textMore: EBContext.resource('VICE'),
		textLess: EBContext.resource('MENE'),
		type: 'legacy',
		display: 'block',
		itemsSelector: 'tileWrap',
		container: toggleEl.getAttribute('data-container')
	}, options);
	let moreContainerEl = EBContext.utils.element.getElement(options.container || toggleEl.parentElement);
	if(!toggleEl.id){
		let teId, i=0;
		do{teId = moreContainerEl.id + '_more' + (i>0 ? '_'+i : '');i++} while(document.getElementById(teId));
		toggleEl.id = teId;
	}
	let wrapEl;
	if(options.type === 'responsive'){
		wrapEl = moreContainerEl;
	} else {
		wrapEl = moreContainerEl.querySelector('.box-visible');
	}
	if(!toggleEl.getAttribute('data-closed-text')) toggleEl.setAttribute('data-closed-text', options.textMore);
	if(!toggleEl.getAttribute('data-opened-text')) toggleEl.setAttribute('data-opened-text', options.textLess);
	let statusEl = moreContainerEl.querySelector('.box-status');
	if(!statusEl){
		statusEl = EBContext.utils.template('<input type="hidden" name="<!--$name-->" id="<!--$name-->" class="box-status">', null, {name: toggleEl.id + '_status'})[0];
		moreContainerEl.appendChild(statusEl);
		EBContext.ajaxNav.restoreElementState(statusEl);
	}
	let opened = (statusEl.value=='1'); //!moreEl.classList.contains('d-none');
	toggleEl.onclick = ()=>toggleMoreItems(wrapEl,toggleEl);
	toggleMoreItems(wrapEl, toggleEl, null, !opened);
	toggleEl.setAttribute('initialized', '');
	return false;
};
var showRentalDetail = seoid=>{
	require(['EBContext_AjaxNavigation'], ()=>{
		let rentalPopupEl = document.getElementById('rentalDetail');
		if(rentalPopupEl) rentalPopupEl.parentElement.removeChild(rentalPopupEl);
		let rentalPopupUrl = EBContext.utils.template(EBContext.data.hrefMap.popup_rental_seoid, {},{seoid: seoid})[0].data;
		EBContext.popup(rentalPopupUrl);
	});
};
var initPopupImg = options => {
	require(['magnific-popup','EBContext'], ()=>{
		options = EBContext.utils.extendObj(false, {
			wrapId: 'page'
		}, options);
		let imgLinkEls = [...document.querySelectorAll('.cmsContent a[data-popup-img]')];
		let galleries = {};
		let defaultSettings = {
			enabled: true,
			preload: [0,2],
			navigateByImgClick: true,
			arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
			tPrev: EBContext.resource('PREDCHOZI_VLEVO'),
			tNext: EBContext.resource('DALSI_VPRAVO'),
			tCounter: '<span class="mfp-counter">%curr% / %total%</span>'
		};
		window.gallery_default = {settings: {enabled: false}};
		imgLinkEls.forEach(el=>{
			let galleryId = el.getAttribute('data-popup-img') || 'default';
			if(Object.keys(galleries).indexOf(galleryId) === -1){
				galleries[galleryId] = {
					settings: window['gallery_' + galleryId] || defaultSettings,
					elements: []
				};
			}
			galleries[galleryId].elements.push(el);
		});
		Object.values(galleries).forEach(gal=>{
			$(gal.elements).magnificPopup({
				type: 'image',
				gallery: gal.settings,
				tClose: EBContext.resource('ZAVRIT_ESC'),
				tLoading: EBContext.resource('NACITAM'),
				image: {tError: EBContext.resource('OBRAZEK_NELZE_NACIST')}
			});
		});
	});
};
var prefixPhone = function(input, options){
	options = EBContext.utils.extendObj(false, {
		countryElName: 'stat'
	}, options);
	let val = input.value;
	let countryEl = input.form.querySelector('[name="' + options.countryElName + '"]');
	let countryVal = null;
	if(countryEl) countryVal = countryEl.value.substr(0,12);
	let countryPrefixMap = {
		'000000000001': '+420',
		'000000000002': '+421'
	};
	if(!(/^(\+|00)(((420|421)\d{9})|((?!(420|421))\d{5,20}))$/g).test(val)){
		if(val && countryVal && Object.keys(countryPrefixMap).indexOf(countryVal) > -1){
			if(val.length !== 9){
				invalidateInput(input, EBContext.resource('MSG_NEPLATNA_DELKA_TEL'));
				return;
			}
			val = countryPrefixMap[countryVal] + val;
			warnInput(input, EBContext.resource('MSG_DOPLNENA_PREDVOLBA'));
			input.value = val;
			return;
		} else if(val) {
			invalidateInput(input, EBContext.resource('MSG_CHYBI_PREDVOLBA'));
			return;
		}
	}
	resetValidity(input);
};
var resetValidity = function(input){
	input.classList.remove('is-invalid');
	[...input.parentElement.querySelectorAll('button.btn')].forEach(el=>{
		el.classList.remove('btn-danger');
		el.classList.remove('btn-info');
		el.classList.add('btn-warning');
		if(el.getAttribute('data-original-title')!==null) el.setAttribute('data-bs-original-title', el.getAttribute('data-original-title'));
	});
	if('function' === typeof input['setCustomValidity']){
		input.setCustomValidity('');
		input.checkValidity();
	}
};
var stripHTML = function(input){
	if(!(input instanceof HTMLElement)){
		const str = input;
		input = document.createElement("div");
		input.innerHTML = str;
	}
	return input.textContent || input.innerText || '';
};
var invalidateInput = function(input, msg, isHTML){
	input.classList.add('is-invalid');
	[...input.parentElement.querySelectorAll('button.btn')].forEach(el=>{
		el.classList.remove('btn-warning');
		el.classList.add('btn-danger');
		if(!isHTML) el.removeAttribute('data-bs-html');
		if(msg){
			if(el.getAttribute('data-original-title')===null) el.setAttribute('data-original-title', el.getAttribute('data-bs-original-title'));
			if(isHTML) el.setAttribute('data-bs-html', 'true');
			el.setAttribute('data-bs-original-title', msg);
			new bootstrap.Tooltip(el);
		}
	});
	if(msg && 'function' === typeof input['setCustomValidity']){
		if(isHTML) msg = stripHTML(msg);
		input.setCustomValidity(msg);
		//input.reportValidity();
	}
};
var warnInput = function(input, msg, isHTML){
	resetValidity(input);
	[...input.parentElement.querySelectorAll('button.btn')].forEach(el=>{
		el.classList.remove('btn-warning');
		el.classList.add('btn-info');
		if(!isHTML) el.removeAttribute('data-bs-html');
		if(msg){
			if(el.getAttribute('data-original-title')===null) el.setAttribute('data-original-title', el.getAttribute('data-bs-original-title'));
			if(isHTML) el.setAttribute('data-bs-html', 'true');
			el.setAttribute('data-bs-original-title', msg);
			new bootstrap.Tooltip(el);
		}
	});
};

var input_decrement = function(btnEl, inputName, callback){
	let inputEl = (btnEl.form ? btnEl.form[inputName] : btnEl.closest('.product').querySelector('[name="' + inputName + '"]'));
	if(inputEl){
		let step = inputEl.step;
		if(step === 'any') inputEl.step = 1;
		inputEl.stepDown();
		if(step === 'any') inputEl.step = "any";
		if(typeof inputEl.onchange === 'function') inputEl.onchange();
		if('function' === typeof callback) callback(inputEl);
	}
};
var input_increment = function(btnEl, inputName, callback){
	let inputEl = (btnEl.form ? btnEl.form[inputName] : btnEl.closest('.product').querySelector('[name="' + inputName + '"]'));
	if(inputEl){
		let step = inputEl.step;
		if(step === 'any') inputEl.step = 1;
		inputEl.stepUp();
		if(step === 'any') inputEl.step = "any";
		if(typeof inputEl.onchange === 'function') inputEl.onchange();
		if('function' === typeof callback) callback(inputEl);
	}
};
document.addEventListener('EBContext.ajaxNav.elementsRestored', ()=>{
	[...document.querySelectorAll('button.show-more[name][id]')].forEach(el=>prepareToggleMore(el, true));
});
document.addEventListener('EBContext.ajaxNav.ready',()=>{
	let cb = el=>{ 
		if(EBContext.utils.element.isEnabled(el) && !el.readOnly){
			let countryElName = el.getAttribute('data-countryelname');
			let opt = null;
			if(countryElName) opt = {countryElName: countryElName};
			prefixPhone(el, opt);
		}
		return el.checkValidity();
	};
	[...document.querySelectorAll('button.show-more')].forEach(el=>prepareToggleMore(el));
	[...document.querySelectorAll('input[type="tel"]:not([initialized])')].forEach(el=>{
		el.addEventListener('blur', e=>cb(e.currentTarget));
		EBContext.utils.element.setOverride(el.closest('form'), 'onsubmit', e=>cb(el));
		el.setAttribute('initialized', '');
	});
	[...document.querySelectorAll('.ebc_input_decrement:not([initialized])')].forEach(el=>{
		 el.addEventListener('click', e=>{
		 	const el = e.currentTarget;
			e.stopPropagation();
			let cb = el.getAttribute('data-callback');
			input_decrement(el, 'amount', EBContext.utils.getObj(cb));
		 });
		 el.style.touchAction='manipulation';
		 el.setAttribute('initialized', '');
	});
	[...document.querySelectorAll('.ebc_input_increment:not([initialized])')].forEach(el=>{
		 el.addEventListener('click', e=>{
		 	const el = e.currentTarget;
			e.stopPropagation();
			let cb = el.getAttribute('data-callback');
			input_increment(el, 'amount', EBContext.utils.getObj(cb));
		 });
		 el.style.touchAction='manipulation';
		 el.setAttribute('initialized', '');
	});
});

/*
 * o�et�en� pro za��zen� s my�� i dotykovou obrazovkou 
 * aby p�i dotykov�m ovl�d�n� na str�nce nep�ek�el kurzor 
 * ale aby se p�i pohybu my�� zase zobrazil.
 */
document.addEventListener('touchstart', ()=>{
	document.body.classList.remove('pointer-device-cursor');
	document.body.classList.add('pointer-device-touch');
});
document.addEventListener('mousemove', ()=>{
	document.body.classList.remove('pointer-device-touch');
	document.body.classList.add('pointer-device-cursor');
});